import React from "react";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useTranslation } from "react-i18next";

const AButtonGamePlay = ({ onClick = () => {}, text, title, sx = {} }) => {
  const { t } = useTranslation();
  const buttonText = text || t("global.play");
  const buttonTitle = title || buttonText;
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item size={{ xs: 12 }}>
        <Button
          sx={{
            minWidth: "180px",
            height: "39px",
            backgroundColor: "#FFCA55",
            color: "#662D91",
            fontWeight: "bold",
            padding: "10px 20px",
            fontSize: "16px",
            textTransform: "uppercase",
            borderRadius: "25px",
            marginBottom: "15px",
            "&:hover": {
              backgroundColor: "#e8af34",
            },
          }}
          data-testid="modalInfoActivities_playGame_btn"
          onClick={onClick}
          title={buttonTitle}
        >
          {buttonText}
        </Button>
      </Grid>
    </Grid>
  );
};

export default AButtonGamePlay;
